import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function AdminPrices() {
  const nav = useNavigate();
  const [brands, setBrands] = useState([]);
  const [editing, setEditing] = useState(null); // { brandId, sizeIdx, field, value }
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/brands').then(r => setBrands(r.data));
  }, []);

  const updatePrice = (brandId, sizeIdx, field, value) => {
    setBrands(prev => prev.map(b => {
      if (b.id !== brandId) return b;
      const sizes = b.sizes.map((s, i) => i === sizeIdx ? { ...s, [field]: parseFloat(value) || 0 } : s);
      return { ...b, sizes };
    }));
  };

  const saveBrand = async (brand) => {
    setSaving(true);
    try {
      await api.put(`/brands/${brand.id}`, { sizes: brand.sizes });
      toast.success(`${brand.name} atualizado!`);
    } catch {
      toast.error('Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="screen bg-gray-50 flex flex-col">
      <div className="bg-[#1A1A2E] px-6 pt-12 pb-6 text-white">
        <button onClick={() => nav('/admin')} className="text-2xl mb-4 block">←</button>
        <h1 className="text-2xl font-black">Gerenciar Preços</h1>
        <p className="text-gray-400 text-sm mt-1">Preço cliente vs repasse entregador</p>
      </div>

      <div className="flex-1 px-4 py-4 overflow-y-auto space-y-4 pb-8">
        {brands.map(brand => (
          <div key={brand.id} className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div className="px-4 py-3 flex items-center gap-2 border-b border-gray-100">
              <span className="text-2xl">{brand.emoji}</span>
              <h3 className="font-black text-gray-800">{brand.name}</h3>
            </div>

            <div className="p-4 space-y-3">
              {brand.sizes.map((size, idx) => (
                <div key={size.size} className="bg-gray-50 rounded-xl p-3">
                  <div className="font-semibold text-gray-700 text-sm mb-2">{size.label}</div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Preço cliente (R$)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={size.customerPrice}
                        onChange={e => updatePrice(brand.id, idx, 'customerPrice', e.target.value)}
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm font-bold text-primary focus:outline-none focus:border-primary"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Repasse entregador (R$)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={size.deliveryPrice}
                        onChange={e => updatePrice(brand.id, idx, 'deliveryPrice', e.target.value)}
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm font-bold text-green-600 focus:outline-none focus:border-green-500"
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-xs text-gray-400 flex justify-between">
                    <span>Margem plataforma</span>
                    <span className="text-orange-600 font-bold">
                      R$ {(size.customerPrice - size.deliveryPrice).toFixed(2)}
                      {' '}({size.customerPrice > 0 ? (((size.customerPrice - size.deliveryPrice) / size.customerPrice) * 100).toFixed(0) : 0}%)
                    </span>
                  </div>
                </div>
              ))}

              <button
                onClick={() => saveBrand(brand)}
                disabled={saving}
                className="w-full py-3 bg-primary hover:bg-primary-dark disabled:opacity-60 rounded-xl font-bold text-white text-sm transition-all active:scale-95"
              >
                {saving ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
